export const setItemToLocalStorage = (key, value) => {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch (e) {
		// console.error('Error setting item to local storage', e);
	}
};

export const getItemFromLocalStorage = (key) => {
	try {
		const value = localStorage.getItem(key);

		return JSON.parse(value);
	} catch (e) {
		return null;
	}
};

export const removeItemFromLocalStorage = (key) => {
	try {
		localStorage.removeItem(key);
	} catch (e) {
		// silently fail
	}
};
